import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import SVGIcon from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

export type AwardsProps = HTMLAttributes<HTMLElement> &
  Partial<{
    starts: number
    forks: number
  }>

const Awards = ({ starts = 1, forks = 2, ...props }: AwardsProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid>
          <div
            className={cn(
              'col-span-4 md:col-span-6 lg:col-span-12',
              'flex items-center justify-end space-x-[1.6rem] pr-[14%]'
            )}
          >
            <div className="flex space-x-[1.6rem]">
              {[...Array(starts)].map((_, index) => (
                <SVGIcon
                  key={`start-award-${index}`}
                  symbol="star-icon"
                  className="h-[4.5rem] w-[4.1rem] fill-[#AB3737]"
                />
              ))}
            </div>

            <div className="flex space-x-[1.6rem]">
              {[...Array(forks)].map((_, index) => (
                <SVGIcon
                  key={`fork-award-${index}`}
                  symbol="fork-icon"
                  className="h-[4.5rem] w-[1.0rem] fill-[#AB3737]"
                />
              ))}
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Awards
